// extracted by mini-css-extract-plugin
export default {"container":"vU5e_3LJhLMYluMvFd_N","subtitle":"RBmrmQ5RpIvSWmKX3hfv"};